const $2a686780f7e8b42e$var$ENDPOINT = 'https://events.cybertrends.co/support-ticket';
const $2a686780f7e8b42e$var$DONE_MSG = 'Thank you for your message. We will get back to you as soon as possible.';
function $2a686780f7e8b42e$export$2e2bcd8739ae039(app) {
    document.getElementById('submit').disabled = false;
    document.querySelector('form').addEventListener('submit', (evt)=>{
        evt.preventDefault();
        const url = new URL(window.location);
        const body = {
            client: {
                app: app,
                version: url.searchParams.get('v'),
                platform: url.searchParams.get('platform')
            },
            name: evt.target.querySelector('input[name="name"').value,
            email: evt.target.querySelector('input[name="email"').value,
            body: evt.target.querySelector('textarea[name="body"').value,
            test: url.searchParams.get('test') === '1'
        };
        fetch($2a686780f7e8b42e$var$ENDPOINT, {
            method: 'post',
            body: JSON.stringify(body)
        }).then(()=>{
            const main = document.querySelector('main');
            const p = document.createElement('p');
            p.innerText = $2a686780f7e8b42e$var$DONE_MSG;
            main.innerHTML = '';
            main.appendChild(p);
        });
    });
}


document.addEventListener('DOMContentLoaded', ()=>(0, $2a686780f7e8b42e$export$2e2bcd8739ae039)('iolo'));


//# sourceMappingURL=support.d88eb79d.js.map
